import styled from 'react-emotion'
import { space16 } from '../style'

export const Container = styled('div')({
  label: 'Container',
  display: 'flex',
  height: '100%',
  alignItems: 'stretch',
  position: 'relative',
  overflow: 'hidden'
})

// right side of app, holds Content
export const ContentArea = styled('div')({
  label: 'ContentArea',
  display: 'flex',
  position: 'relative',
  flex: 1,
  flexDirection: 'column',
  height: '100%'
})

// Stack on top of eachother within ContentArea
// eg single block view overlays board view
const Content = styled('div')(({ scroll }) => ({
  label: 'Content',
  position: 'absolute',
  width: '100%',
  height: '100%',
  background: 'white',
  display: 'flex',
  flexDirection: 'column',
  overflow: scroll && 'auto',
  paddingBottom: scroll && space16
}))

export default Content
